/* global dataLayer */

import { Controller } from 'stimulus';

class RelatedCartProductsModalController extends Controller {
  onSubmit(event) {
    event.preventDefault();

    const form = event.target;

    const submitButton = form.querySelector('button[type="submit"]');

    if (!submitButton) return;

    submitButton.innerHTML = `
      <svg
        class="icon icon-check"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
      >
        <path d="M11.06,27.88a2.82,2.82,0,0,1-2-.82L.83,18.82a2.82,2.82,0,0,1,4-4l6.24,6.24L27.18,4.94a2.82,2.82,0,0,1,4,4L13.06,27.06A2.82,2.82,0,0,1,11.06,27.88Z" />
      </svg>

      Toegevoegd
    `;

    const { price, variantId } = form.dataset;

    this.sendToGTM(variantId, price);
  }

  // eslint-disable-next-line
  sendToGTM(id, price) {
    if (typeof dataLayer === 'undefined') return;

    dataLayer.push({
      event: 'add_to_cart',
      conversion_value: price || 0,
      product_id: id,
    });
  }
}

RelatedCartProductsModalController.targets = [
  //
];

export default RelatedCartProductsModalController;
